import { Controller } from 'libraries/front-end-core/core/Router'
import { LEGISLATION_FOLDERS } from 'constants/feature-flags'
import { LEGISLATION_MENU } from 'constants/controllers'
import Main from './Main'
import Header from './Header'

export default new Controller({
  name: LEGISLATION_MENU,
  route: LEGISLATION_FOLDERS ? 'legislation/all' : 'legislation',
  controller (Router, { url, scrollMain, pageView, pageData, params: { aol, path = null }, previousPageId, query }, render) {
    const pageId = url

    render(
      { Main, Header },
      { act: path, scrollMain },
      {
        pageId,
        searchType: 'legislation',
        className: 'legislation legislation-accordion-namespace'
      }
    )

    return pageId
  }
})
